<div class="loader">
  <p class="loader-text fw-bold fs-3">
    {{ loadingText }}
  </p>
  <div class="la-ball-spin-clockwise la-3x">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
